<template>

<div class="album-list-container">
    mv列表页
</div>

</template>

<script>

export default {
    name: 'mv-list'
}

</script>

<style lang="scss">
@import "./style"
</style>



// WEBPACK FOOTER //
// index.vue?39ee0ab6